var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var TemplateValueService = /** @class */ (function (_super) {
    __extends(TemplateValueService, _super);
    function TemplateValueService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        return _this;
    }
    TemplateValueService.prototype.getTemplate = function () {
        this.baseUrl = '/v1/gen/contents-template-m-service?query={"orderByList":[{"name":"id","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.id, display: item.title, data: item });
            }
            return options;
        }));
    };
    TemplateValueService.prototype.checkItem = function (rec) {
        var check = true;
        if (!this.colservice.checkVal(rec.template_id)) {
            check = false;
        }
        if (rec.values && rec.values.length > 0) {
            for (var _i = 0, _a = rec.values; _i < _a.length; _i++) {
                var value = _a[_i];
                if (!this.colservice.checkVal(value.tag)) {
                    check = false;
                    break;
                }
            }
        }
        return check;
    };
    TemplateValueService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TemplateValueService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return TemplateValueService;
}(ContentBaseService));
export { TemplateValueService };
var Template = /** @class */ (function () {
    function Template() {
    }
    return Template;
}());
export { Template };
var TemplateDetail = /** @class */ (function () {
    function TemplateDetail() {
        this.values = [];
    }
    return TemplateDetail;
}());
export { TemplateDetail };
var TemplateValue = /** @class */ (function () {
    function TemplateValue() {
    }
    return TemplateValue;
}());
export { TemplateValue };
//# sourceMappingURL=template-value.service.js.map